/*
 * @Author: zouyaoji@https://github.com/zouyaoji
 * @Date: 2021-04-06 09:23:38
 * @LastEditTime: 2021-09-09 09:46:57
 * @LastEditors: zouyaoji
 * @Description:
 * @FilePath: \vue-cesium-v2\src\exts\imageryProvider\TiandituMapsStyle.js
 */
const TiandituMapsStyle = {
  IMG_W: 'img_w',
  IMG_C: 'img_c',
  CIA_W: 'cia_w',
  CIA_C: 'cia_c',
  VEC_W: 'vec_w',
  VEC_C: 'vec_c',
  TER_W: 'ter_w',
  TER_C: 'ter_c',
  CVA_W: 'cva_w',
  CVA_C: 'cva_c',
  CTA_W: 'cta_w',
  CTA_C: 'cta_c',
  EIA_W: 'eia_w',
  EIA_C: 'eia_c',
  EVA_W: 'eva_w',
  EVA_C: 'eva_c',
  IBO_C: 'ibo_c',
  IBO_W: 'ibo_w'
}
export default TiandituMapsStyle
